<template>
  <div class="shops needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="shop.title" :text="info.infoKey" ></Info>
    <div class="shops-title">
      <h3>{{$t('shop.title')}}</h3>
      <h2>{{$t('shop.description')}}</h2>
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t('rank')}}
          </div>
          <div class="cell header">
            {{$t('shops')}}
          </div>
          <div class="cell header">
            {{$t('tickets')}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row" v-for="(shop, index) in result.aggregations['to-bills'].bills.shopName.buckets">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{shop.key}}
          </div>
          <div class="cell" data-title="ARTICLES">
            {{shop.doc_count | getKNumber | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{shop.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Produitn2',
    components: {
      Info
    },
    props: {
      result: Object,
      search: Object
    },
    data() {
      return {
        fullscreen: false,
        info: {
         infoKey: this.getInfoKey()
        },
      }
    },
    mounted() {
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      },
      getInfoKey() {
        return "shop.info";
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/shops.sass"
</style>
